<template>
  <div class="news__body">
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div v-if="isLoading" class="news__loading">
      <Loading />
    </div>
    <div v-else-if="isEmptyNewsList" class="news__empty__area">
      <p class="news__empty__title">現在お知らせはありません</p>
      <p class="news__empty__detail">
        サービスのメンテナンスや
        <br />
        機能のアップデート情報などが
        <br />
        こちらに通知されます
      </p>
    </div>
    <div v-else class="news__news-content">
      <NewsBoxes :news-list="newsList" />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import dayjs from 'dayjs'
import FeedbackError from '../../atoms/feedbacks/feedback-error.vue'
import Loading from '../../atoms/loadings/Loading.vue'
import NewsBoxes from '../../organism/notifications/news/NewsBoxes.vue'

export default {
  components: { FeedbackError, Loading, NewsBoxes },
  data() {
    return {
      newsList: [],
      isLoading: false,
      showableErrorFeedback: false,
      errorMessage: ''
    }
  },
  computed: {
    isEmptyNewsList() {
      return this.newsList.length === 0
    }
  },
  mounted() {
    this.getNews()
  },
  methods: {
    async getNews() {
      this.isLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/announcements/notices')
        this.newsList = res.data.data
          .map(news => news.attributes)
          .map(news => ({
            id: news.id,
            title: news.title,
            startedAt: dayjs(news.started_at).format('YYYY年M月D日')
          }))
        this.$emit('news-loaded', this.isEmptyNewsList)
      } catch (error) {
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.showableErrorFeedback = true
      }
      this.isLoading = false
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    async onClickPageLink(page) {
      this.scrollToTop()
      await this.getNews(page)
      this.updateUrlFromParams()
    },
    scrollToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>
<style lang="scss" scoped>
.news {
  overflow: hidden;

  &__loading {
    padding: 24px;
  }

  &__empty {
    &__area {
      padding: 28px 0 44px;
    }

    &__title {
      @extend %body-bold;
      color: $gray-1;
      margin-bottom: 8px;
    }

    &__detail {
      @extend %body;
      color: $gray-1;
      line-height: 1.6;
    }
  }

  &__body {
    background-color: $white;
    padding-top: 24px;
  }

  &__news-content {
    padding-bottom: 56px;
  }
}
</style>
